import { render, staticRenderFns } from "./BaseTab.vue?vue&type=template&id=44651ce8&"
import script from "./BaseTab.vue?vue&type=script&lang=ts&"
export * from "./BaseTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports